import React, { useState, useEffect } from "react";
// import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  Box,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  TextField,
  Grid,
  Typography,
  Autocomplete
} from "@mui/material";

import {
  getMentorEmail,
  getMentorName
} from "../../../../../core/service/mentor.service";
import { InputField, SelectField, DatePickerField } from "../../FormFields";
import { useField, useFormikContext } from "formik";
import { facultyOption } from "../../../../../_mock_/faculty";

const c2fScholarshipProgramOption = [
  {
    value: "normalCourse3yrs",
    label: "Normal Course 3 yrs"
  },
  {
    value: "continuingCourse5yrs",
    label: "Continuing Course 5 yrs"
  }
];

export default function PersonalInformation2(props) {
  const formikProps = useFormikContext();
  const [mentorNameOption, setMentorNameOption] = useState([
    { value: "", label: "" }
  ]);
  const [mentorEmailOption, setMentorEmailOption] = useState([
    { value: "", label: "" }
  ]);

  useEffect(() => {
    const getMentorNameAndEmail = async () => {
      const mentorName = await getMentorName();
      const mentorEmail = await getMentorEmail();
      setMentorNameOption(mentorName);
      setMentorEmailOption(mentorEmail);
    };

    getMentorNameAndEmail();
  }, []);

  const {
    formField: {
      faculty,
      major,
      c2fScholarshipProgram,
      mobileThai,
      mobileCountry,
      mentor_id,
      mentorName,
      mentorEmail,
      startFellowship,
      contractEnd,
      researchArea,
      addressInThailand,
      addressInTheCountryOfResidence
    }
  } = props;

  const [mentorNameField, mentorNameMeta] = useField(mentorName);
  const [mentorEmailField, mentorEmailMeta] = useField(mentorEmail);

  return (
    <>
      <Box sx={{ marginBottom: 3 }}>
        <Typography variant="h6" gutterBottom>
          PhD Student Information
        </Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <SelectField
            name={faculty.name}
            label={faculty.label}
            data={facultyOption}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={major.name}
            label={major.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <SelectField
            name={c2fScholarshipProgram.name}
            label={c2fScholarshipProgram.label}
            data={c2fScholarshipProgramOption}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={mobileThai.name}
            label={mobileThai.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={mobileCountry.name}
            label={mobileCountry.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <Autocomplete
            options={mentorNameOption}
            onChange={(e, result) => {
              formikProps.setFieldValue(mentor_id.name, result.value);
              formikProps.setFieldValue(mentorName.name, result.label);
              formikProps.setFieldValue(mentorEmail.name, result.value);
            }}
            value={mentorNameField.value}
            isOptionEqualToValue={(option, value) => option.label === value}
            renderInput={(params) => (
              <TextField
                name={mentorNameField.name}
                label={mentorName.label}
                error={Boolean(mentorNameMeta.touched && mentorNameMeta.error)}
                helperText={mentorNameMeta.touched && mentorNameMeta.error}
                {...params}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <FormControl fullWidth disabled>
            <InputLabel>{mentorEmail.label}</InputLabel>
            <Select
              name={mentorEmail.name}
              value={mentorEmailField.value}
              label={mentorEmail.label}
            >
              {mentorEmailOption.map((item, index) => (
                <MenuItem key={index} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <DatePickerField
            // name={startFellowship.name}
            // label={startFellowship.label}
            // format="MM/yy"
            // views={["year", "month"]}
            // minDate={new Date("1980/12/31")}
            // maxDate={new Date()}
            // fullWidth
            // inputVariant="outlined"

            name={startFellowship.name}
            label={startFellowship.label}
            inputFormat="dd/MM/yyyy"
            // disableFuture
            minDate={new Date("1950/12/31")}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <DatePickerField
            // name={contractEnd.name}
            // label={contractEnd.label}
            // format="MM/yy"
            // views={["year", "month"]}
            // minDate={new Date("1980/12/31")}
            // maxDate={new Date()}
            // fullWidth
            // inputVariant="outlined"

            name={contractEnd.name}
            label={contractEnd.label}
            inputFormat="dd/MM/yyyy"
            minDate={new Date("1950/12/31")}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={researchArea.name}
            label={researchArea.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={addressInThailand.name}
            label={addressInThailand.label}
            fullWidth
            multiline
            rows={4}
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={addressInTheCountryOfResidence.name}
            label={addressInTheCountryOfResidence.label}
            fullWidth
            multiline
            rows={4}
            variant="outlined"
          />
        </Grid>
      </Grid>
    </>
  );
}
